import { Defaults } from 'es-decorators'
import { View } from 'es6/components/view'
import isArray from 'lodash/isArray'
import extend from 'lodash/extend'
import each from 'lodash/each'
import Compressor from 'compressorjs'
import $ from 'init/jquery'
import { isIE11 } from 'init/browser-check'

/**
 * Общий вид формы
 * Определяет обработку сохранения формы
 */
@Defaults({
  formElement: '.field',
  formName: '',
  uploadOptions: {
    compress: {
      quality: 0.6,
      convertSize: 2000000,
      maxWidth: 3840,
      maxHeight: 3840,
      checkOrientation: true,
    },
    fileField: '',
    itemIdField: '',
    urlRoot: '',
  },
  additionalOptions: [
    'formElement',
    'checkAgreement', // показывает, необходима ли проверка соглашения на обработку данных
    'formName',
  ],
})
export class FormView extends View {
  /**
   * @inheritDoc
   */
  run () {
    if (this.checkAgreement) {
      this.$('.label-data-processing-agreement').removeClass('not_display')
    }
    this.updateFieldsList()
  }

  /**
   * Обновление списка полей
   */
  updateFieldsList () {
    this.$fields = this.$(this.formElement)
  }

  /**
   * Сбор данных с полей формы
   * @returns {Object} собранные данные
   */
  getData () {
    let data = {}
    this.$fields.each((i, field) => {
      let input = this.$(field),
        name = input.attr('name')
      if (input.is(':checkbox')) {
        if (this.$(this.formElement + '[name="' + name + '"]:checkbox').length > 1) {
          if (!data[name]) {
            data[name] = []
          }
          if (input.prop('checked')) {
            data[name].push(input.val())
          }
          return
        }
        data[name] = input.prop('checked')
        return
      }
      if (input.is(':radio') && input.prop('checked')) {
        data[name] = input.val()
        return
      }
      if (input.attr('type') === 'tel') {
        data[name] = input.val()
        return
      }
      // Проверка нужна, чтобы не выбранные радио-баттоны не перезаписывали значение выбранного
      if (!data[name]) {
        data[name] = input.val()
      }
    })
    return data
  }

  /**
   * Метод для сохранения модели формы
   */
  save () {
  }

  /**
   * Обработчик успешного сохранения формы
   * @param {Object} successEvent
   */
  success (successEvent) {
    this.clearErrors()
    this.trigger(successEvent, this.model)
    this.onSave = false
  }

  /**
   * Обработчик ошибки сохранения формы
   * @param {Object} model Модель
   * @param {Object} response Ответ сервера
   */
  error (model, response) {
    this.clearErrors()
    let errors
    if (response.status === 422) {
      try {
        errors = JSON.parse(response.responseText)
      } catch (e) {
        let error = new SyntaxError('Parsing data with form errors caused the error. JSON: ' + response.responseText)
        if (e.stack) {
          error.stack = e.stack
        }
        if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
          Raven.captureException(error)
        } else {
          throw error
        }
      }
      if (isArray(errors)) {
        this.fillErrors(errors)
      }
      const errorFields = this.$(this.formElement + '.error, .input-fake.error')
      if (errorFields.length && !this.noScroll) {
        const firstErrorField = errorFields.eq(0)
        const $scrollableBlock = this.isMobilePopup ? this.$el : $('html, body')
        $scrollableBlock.animate({
          scrollTop: firstErrorField.offset().top + firstErrorField.height() + 100 - $(window).height() / 2,
        }, 500)
      }
    }
    this.onSave = false
  }

  /**
   * Заполнение ошибок
   * @param {Array} errors массив ошибок формы
   */
  fillErrors (errors) {
    errors.forEach(error => {
      this.$(`#${this.formName}-${error.field}-error`).text(error.message)
      this.$(`#${this.formName}-${error.field}`).addClass('error')
    })
  }

  /**
   * Очистка ошибок
   */
  clearErrors () {
    this.$fields.each((i, field) => {
      $(field).removeClass('error')
    })
    this.$('.error-message:not(.js-not-validate)').text('')
    this.$('.example.not_display').removeClass('not_display')
  }

  /**
   * Загрузка и отрисовка превью файлов.
   * @param {Event} e Событие добавления файла.
   * @param {Array} files Массив с файлами.
   */
  photoUpload (e, files) {
    window.URL = window.URL || window.webkitURL
    const $input = e ? $(e.currentTarget) : false
    const filesArr = $input ? $input[0].files : files
    const itemId = this.model.get('id')
    let options = this.uploadOptions && this.uploadOptions.compress
      ? this.uploadOptions.compress
      : {}
    options = extend(options, {
      success: result => {
        this.prepareToUpload(result, itemId)
        this.trigger('file-prepared')
      },
    })
    each(filesArr, file => {
      if (
        this.uploadOptions
        && this.uploadOptions.compress
        && (
          file.type === 'image/png'
          || file.type === 'image/jpeg'
        )
      ) {
        this.compressor = new Compressor(file, options, isIE11)
      } else {
        this.prepareToUpload(file, itemId)
        this.trigger('file-prepared')
      }
    })
  }

  /**
   * Подготовка файла к загрузке
   * @param {File} file Файл
   * @param {number} itemId Id сущности к которой привязан файл
   */
  prepareToUpload (file, itemId) {
    let formData = new FormData(),
      fileField = this.uploadOptions && this.uploadOptions.fileField
        ? this.uploadOptions.fileField
        : '',
      itemIdField = this.uploadOptions && this.uploadOptions.itemIdField
        ? this.uploadOptions.itemIdField
        : '',
      uploadImmediately = !this.uploadOptions
        || !this.uploadOptions.notUploadImmediately
    // Валидируем файл перед отправкой
    if (!this._validateFile(file)) {
      return
    }
    if (!fileField) {
      throw new Error('Field name for file upload is not defined.')
    }
    formData.append(fileField, file, file.name)
    if (itemIdField) {
      formData.append(itemIdField, itemId)
    }
    this._renderFilePreview(file, itemId)
    // если модель уже создана сохраняем файлы на сервер, если нет, сохраняем в this.notLoaded
    if ((!itemIdField || (itemIdField && itemId)) && uploadImmediately) {
      this.postFormData(formData)
    } else {
      this.notLoaded.push(formData)
    }
  }

  /**
   * Валидация размера файла
   * @param {File} file
   * @returns {boolean} true если меньше допустимого
   * @private
   */
  _validateFile (file) {
    return file.size < 2097152
  }

  /**
   * Рендеринг превью файла
   *
   * @private
   */
  _renderFilePreview () {}

  /**
   * Обработка успешной загрузки файла
   *
   * @private
   */
  _uploadSuccess () {}

  /**
   * Обратка ошибки
   * @param {string} error
   * @param {Object} formData
   * @private
   */
  _uploadError (error, formData) {
    if (this.notLoaded) {
      this.notLoaded.push(formData)
    }
    this.error(this.model, error)
  }

  /**
   * Загрузка файлов на сервер
   *
   * @param {FormData} formData Данные для загрузки на сервер.
   * @param {Array} loaded Массив загруженных файлов.
   * @returns {Request} Запрос на загрузку.
   */
  postFormData (formData, loaded = []) {
    const urlRoot = this.uploadOptions && this.uploadOptions.urlRoot
    if (!urlRoot) {
      throw new Error('URL for file upload is not defined.')
    }
    return $.ajax({
      url: urlRoot,
      method: 'POST',
      cache: false,
      contentType: false,
      processData: false,
      async: false,
      data: formData,
      headers: this.headerUpload ? this.headerUpload : {},
    })
      .done(data => {
        this._uploadSuccess(data, loaded)
        this.trigger('upload-success', data)
      })
      .fail(error => {
        this._uploadError(error, formData)
        this.trigger('upload-error', error)
      })
  }
}
